<template>
  <div class="home-main">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="400000000"
      controls
      indicators
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      class="carousel-main"
    >
      <b-carousel-slide :img-src="this.homeImage[0].img">
        <h3>
          <strong>VILLA</strong>&nbsp; &nbsp;
          <span class="second-word">ANDALUZA</span>
        </h3>
        <ul>
          <li>
            <font-awesome-icon :icon="['fas', 'map']" />&nbsp; &nbsp; &nbsp;
            CABO SAN LUCAS, MEXICO
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'bed']" />&nbsp; &nbsp; &nbsp;
            SLEEPS 12
          </li>
          <li class="booking-scroll-link">
            <router-link class="main-link" to="/villaandaluza">
              MORE DETAILS &nbsp; &nbsp; &nbsp;
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </router-link>
          </li>
        </ul>
      </b-carousel-slide>
      <b-carousel-slide :img-src="this.homeImage[1].img">
        <h3>
          <strong>VILLA</strong>&nbsp; &nbsp;
          <span class="second-word">VERANZA</span>
        </h3>
        <ul>
          <li>
            <font-awesome-icon :icon="['fas', 'map']" />&nbsp; &nbsp; &nbsp;CABO
            SAN LUCAS, MEXICO
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'bed']" />&nbsp; &nbsp;
            &nbsp;SLEEPS 16
          </li>
          <li class="booking-scroll-link">
            <router-link class="main-link" to="/villaveranza">
              MORE DETAILS &nbsp; &nbsp; &nbsp;
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </router-link>
          </li>
        </ul>
      </b-carousel-slide>
      <b-carousel-slide :img-src="this.homeImage[2].img">
        <h3>
          <strong>BLUE</strong>&nbsp; &nbsp;
          <span class="second-word">BAY</span>
          301
        </h3>
        <ul>
          <li>
            <font-awesome-icon :icon="['fas', 'map']" />&nbsp; &nbsp; &nbsp;CABO
            SAN LUCAS, MEXICO
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'bed']" />&nbsp; &nbsp;
            &nbsp;SLEEPS 4
          </li>
          <li class="booking-scroll-link">
            <router-link class="main-link" to="/bluebay301">
              MORE DETAILS &nbsp; &nbsp; &nbsp;
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </router-link>
          </li>
        </ul>
      </b-carousel-slide>
      <b-carousel-slide :img-src="this.homeImage[3].img">
        <h3>
          <strong>BLUE</strong>&nbsp; &nbsp;
          <span class="second-word">BAY</span>
          302
        </h3>
        <ul>
          <li>
            <font-awesome-icon :icon="['fas', 'map']" />&nbsp; &nbsp; &nbsp;CABO
            SAN LUCAS, MEXICO
          </li>
          <li>
            <font-awesome-icon :icon="['fas', 'bed']" />&nbsp; &nbsp;
            &nbsp;SLEEPS 6
          </li>
          <li class="booking-scroll-link">
            <router-link class="main-link" to="/bluebay302">
              MORE DETAILS &nbsp; &nbsp; &nbsp;
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </router-link>
          </li>
        </ul>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      slide: 0,
      sliding: null,
      homeImage: [
        {
          id: 1,
          img: require("../assets/gallery/villas/villa_andaluza/web/Andaluza-3-min.jpg"),
        },
        {
          id: 2,
          img: require("../assets/gallery/villas/villa_veranza/web/Veranza-6-min.jpg"),
        },
        {
          id: 3,
          img: require("../assets/gallery/villas/blue_bay/web/301/blue_bay_tv.jpeg"),
        },
        {
          id: 4,
          img: require("../assets/gallery/villas/blue_bay/web/302/blue_bay_living_2_302.jpeg"),
        },
      ],
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
      console.log(slide);
    },
    onSlideEnd(slide) {
      this.sliding = false;
      console.log(slide);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/main";

.home-main {
  overflow: hidden;
}

.booking-scroll-link {
  cursor: pointer;
  position: relative;
  a {
    &:hover {
      color: $text--blue--dark;
    }
  }
  .fa-chevron-right {
    position: absolute;
    top: 12%;
    left: 100%;
    margin-left: 5px;
    transition: all 0.3s ease-in-out;
  }
  &:hover {
    .fa-chevron-right {
      left: 105%;
    }
  }
}
</style>
<style lang="scss">
@import "../styles/main";
.home-main {
  height: 100%;
}
.carousel-main {
  height: 100%;
  .carousel-inner {
    height: 100%;
    .carousel-item {
      height: 100%;
      img {
        height: 100% !important;
        max-width: initial;
        object-fit: cover;
      }
      a {
        color: white;
      }
    }
  }
}
.carousel-caption {
  z-index: 0 !important;
  font-family: "Raleway", sans-serif;
  background-color: rgba(0, 0, 0, 0.6);
  bottom: 40% !important;
  right: 0 !important;
  left: 0 !important;
  width: 100%;
  padding-bottom: 24px !important;
  margin: auto;
  ul {
    display: flex;
    list-style: none;
    justify-content: space-around;
    width: 60%;
    margin: auto;
    color: white;
    font-weight: 700;
    background-color: rgba(0, 0, 0, 0.6);
    width: 100%;
    padding-left: 18%;
    padding-right: 20%;
    padding-top: 20px;
    padding-bottom: 20px;
    li:nth-child(3) {
      color: $text--blue--dark;
    }
    li {
      svg {
        color: $text--blue--dark;
      }
    }
    @media only screen and (max-width: 800px) {
      padding-left: 1%;
      padding-right: 3%;
    }
  }

  h3 {
    font-size: 5em;
    margin-bottom: 40px;
    margin-top: 40px;
    font-weight: 800;
  }
  .second-word {
    font-weight: 300;
    font-family: "Raleway";
  }

  p {
    background-color: black;
    width: 100%;
    padding-left: 25%;
    padding-right: 25%;
  }
}

//simple media query to adjust carousel caption, will clean up later
@media only screen and (max-width: 1000px) {
  h3 {
    font-size: 2em !important;
    margin: auto !important;
  }
  ul {
    font-size: 10px !important;
    bottom: 20% !important;
  }
}
</style>
